import { __rest } from "tslib";
import React from 'react';
import { Link, SwitchCheckbox, Typography } from '@klarna/bubble-ui';
import styled from 'styled-components';
export const TERMS_AND_CONDITIONS_TRANSLATION_KEY = 'products-fe.components.product_prices_card.pricing_annex.before_link';
const AgreementWrapper = styled.div.withConfig({ displayName: "AgreementWrapper", componentId: "sc-wmwgjv" }) `
  display: flex;
  justify-content: flex-start;
`;
const TermsAndConditions = (_a) => {
    var { termsData } = _a, props = __rest(_a, ["termsData"]);
    if (!termsData) {
        return null;
    }
    if (!termsData.length) {
        return null;
    }
    return (React.createElement(React.Fragment, null, termsData.map(term => (React.createElement(Term, Object.assign({ key: term.fallback_label, term: term }, props))))));
};
const Term = ({ term, selectedTerms, hasAcceptedTerms, isLoading, onChange, t, }) => {
    const isSelected = selectedTerms.includes(term.url);
    const isChecked = hasAcceptedTerms || isSelected;
    return (React.createElement(AgreementWrapper, null,
        React.createElement(SwitchCheckbox, { key: term.url, onChange: onChange(term.url), checked: isChecked, disabled: hasAcceptedTerms || isLoading }),
        React.createElement(Typography, { textToken: "text-style/text/super-paragraphs/body/regular" },
            t(TERMS_AND_CONDITIONS_TRANSLATION_KEY),
            "\u00A0",
            React.createElement(Link, { inParagraph: true, href: term.url, target: "_blank" }, t(term.label, {}, term.fallback_label)))));
};
export default TermsAndConditions;
